import React from "react";

const DEFAULT_COLOR_MAP = {
  scheduled:   { bg: "#eff6ff", color: "#1d4ed8", label: "Scheduled" },
  active:      { bg: "#dcfce7", color: "#15803d", label: "Active" },
  in_progress: { bg: "#dbeafe", color: "#1d4ed8", label: "In Progress" },
  at_risk:     { bg: "#fff7ed", color: "#c2410c", label: "At Risk" },
  overdue:     { bg: "#fee2e2", color: "#dc2626", label: "Overdue" },
  completed:   { bg: "#dcfce7", color: "#15803d", label: "Completed" },
  pending:     { bg: "#f1f5f9", color: "#475569", label: "Pending" },
};

export default function StatusBadge({ status, colorMap }) {
  const map = colorMap || DEFAULT_COLOR_MAP;
  const s = map[status] || { bg: "#f1f5f9", color: "#475569", label: status };
  return (
    <span style={{
      background: s.bg, color: s.color, border: `1px solid ${s.color}33`,
      borderRadius: 999, padding: "3px 10px", fontSize: 12, fontWeight: 700,
    }}>
      {s.label}
    </span>
  );
}
